import _ from "lodash";
import { InputSelector } from "./InputSelector";
import { IBaseFormProps } from "../interfaces";

const baseMediaFields = ["media_type", "caption", "credit"];
const baseTypeFields = {
  video: ["video", "media_title_image", "subtitles", "silent_video"],
  image: ["object_location", "image"],
};

const imageHint = {
  media: "Must be a JPG or PNG file; at least 1920px on the long edge",
};

const videoHint = {
  media: "Videos must be H.264 mp4, 25fps, CBR, 22mbps",
};

const subtitlesHint = {
  media: "SRT File",
};

export const handleMediaSchema = (type: string, model: string, schema: any) => {
  const addTypeFields =
    type in baseTypeFields
      ? baseTypeFields[type as keyof typeof baseTypeFields]
      : [];

  const filters = [...baseMediaFields, ...addTypeFields];
  const filteredSchema = schema.filter((item: any) =>
    _.includes(filters, item.name)
  );

  const schemaWithHints = filteredSchema.map((item: any) => {
    if (item.name === "image" && model in imageHint) {
      return {
        ...item,
        overrideHint: imageHint[model as keyof typeof imageHint],
      };
    } else if (item.name === "video" && model in videoHint) {
      return {
        ...item,
        overrideHint: videoHint[model as keyof typeof videoHint],
      };
    } else if (item.name === "subtitles" && model in subtitlesHint) {
      return {
        ...item,
        overrideHint: subtitlesHint[model as keyof typeof subtitlesHint],
      };
    } else if (item.name === "media_title_image" && type === "video") {
      return {
        ...item,
        overrideRequired: true,
      };
    }
    return item;
  });

  return schemaWithHints;
};

/**
 *
 * @param schema loaded schema
 * @param modelName name of model
 * @param itemData itemData state
 * @param setItemData setItemData state
 * @returns
 */
const MediaForm = ({
  schema,
  modelName,
  itemData,
  setItemData,
  customModel,
  onSubmit,
}: IBaseFormProps): JSX.Element => {
  const updateItemData = (keyname: string, value: any) => {
    if (_.has(itemData, keyname))
      setItemData({
        ...itemData,
        [keyname]: value,
      });
  };

  const filteredSchema = handleMediaSchema(
    itemData.media_type,
    customModel || modelName,
    schema
  );

  return (
    <form onSubmit={onSubmit} id="base-form">
      <div className="flex flex-col gap-4">
        {filteredSchema.map((item: any, index: number) => {
          return (
            <InputSelector
              value={itemData[item.name]}
              key={index}
              onChange={(e) => {
                updateItemData(
                  item.name,
                  item.type === "number"
                    ? e.target.valueAsNumber
                    : item.type === "bool"
                    ? e.target.checked
                    : e.target.value
                );
              }}
              modelname={modelName}
              customModel={customModel}
              {...item}
            />
          );
        })}
      </div>
    </form>
  );
};

export default MediaForm;
